<template>
	<div class="tree-container">
		<!--选择成员弹出 start-->
		<el-dialog
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="35%">
			<div class="dialog-input flex flex-middle" slot="title">
				<label class="f14 font-weight-bold mr5">选择组织部门</label>
			</div>
			<div class="mt10">
				<el-input size="small" placeholder="输入搜索内容" v-model="filterText" clearable></el-input>
			</div>
			<el-tree
				:data="treeData"
				show-checkbox
				node-key="groupId"
				:check-strictly="true"
                ref="tree"
				:props="defaultProps"
				@check="handleCheck"
                :filter-node-method="filterNode" class="tree-box mt10">
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<span>
						<i class="el-icon-folder-opened"></i>
						{{ node.label }}
					</span>
				</span>
			</el-tree>
			<div class="flex flex-center mt20">
				<el-button size="small" class="save-btn" type="primary" @click="submit()">确定</el-button>
			</div>
		</el-dialog>
		<!--选择成员弹出 end-->
	</div>
</template>
<script>
export default {
	name: "ReportMember",
	data() {
		return {
			filterText: "",
			dialogVisible: false,
			treeData: [],
			defaultProps: {
				children: "children",
				label: "groupName"
			},
			filterData:[]
		};
    },
    watch: {
        filterText(val) {
			this.filterData = [];
            this.$refs.tree.filter(val);
        }
    },
	methods: {
		// 显示弹窗
		init(data,selectUser) {
            this.dialogVisible = true;
            this.$nextTick(() => {
				this.filterText=""
				this.treeData = data;
				if(selectUser){
					this.$refs.tree.setCheckedKeys(selectUser)
				}

            })
		},
		// 搜索
        filterNode(value, data) {
			if (!value) return true;
			return data.groupName.indexOf(value) !== -1;
		},
		// 单选
		handleCheck(node,nodes) {
			this.$refs.tree.setCheckedKeys([]);
			if(nodes.checkedKeys.length != 0) {
				this.$refs.tree.setCheckedKeys([node.groupId]);
			}
		},
		// 保存
		submit() {
			let arr = this.$refs.tree.getCheckedNodes();
			if(arr.length > 0) {
				this.$emit('groupIdListener',arr[0].groupId);
				this.$emit('groupNameListener',arr[0].groupName);
			}else {
				this.$emit('groupIdListener','');
				this.$emit('groupNameListener','');
			}
			this.dialogVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.tree-container{
 /deep/ .el-dialog__body{
	padding:15px 20px;
	}
}
.el-tree{
    height: 360px;
    overflow: auto;
}
</style>
